import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[labelBox]'
})
export class LabelBoxDirective {
  // por enquanto sempre aplica classe (essa classe deve estar no css global do projeto)
  // obs: acho uma boa prática usar 'directive' no começo do seletor para não ter risco de conflito
  @HostBinding('class.directive--label-box') applyClass = true; 

  constructor() {}

}
